import React from 'react';

const Contractor = ({ rowData }) => {
    const contractor = rowData.contractor;  
    return (
        <span>  
            {contractor ? (  
                <>  
                    {contractor.full_name && !contractor.company_name && contractor.full_name}  
                    {contractor.full_name && contractor.company_name && (  
                        <>  
                            {contractor.full_name}<br />  
                            {contractor.company_name}  
                        </>  
                    )}  
                </>  
            ) : (  
                "آزاد"  
            )}  
        </span>  
    );
}

export default Contractor;